export const environment = {
  baseUrl: '/api-v2',
  baseMapService: 'https://gis.epa.guam.gov/arcgis/rest/services/Imagery/SatImageryMerged/MapServer',
  referenceMapService: 'https://cdn.arcgis.com/sharing/rest/content/items/30d6b8271e1849cd9c3042060001f425/resources/styles/root.json',
}
